import React from "react";
import clsx from "clsx";

export function NotificationCategoryBadge({
    categoryKey,
    className,
    children,
}: {
    categoryKey?: string;
    className?: string;
    children: React.ReactNode;
}) {
    return (
        <span
            className={clsx(
                "inline-flex max-w-full rounded-full px-2 py-0.5 font-semibold",
                categoryKey === "warning"
                    ? "bg-rose-700/10 text-rose-700"
                    : "bg-grass-500/10 text-grass-700",
                className,
            )}
        >
            {children}
        </span>
    );
}
